import React, { useEffect } from 'react';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { verifyCalendarRequest, verifyNewCalendarRequest } from '../redux/action';
import CandidateSlots from '../component/CandidateCalenderNew/CandidateSlots';

const CandidateCalendarSync = ({ type }) => {
    const dispatch = useDispatch();
    let { calendarId, interviewId, tenantId = Cookies.get('tenantId') ?? null } = useParams();
    const verifyCalendar = useSelector((state) => state.CalendarR.verifyCalendarRequest);
    const verifyNewCalendar = useSelector((state) => state.CalendarR.verifyNewCalendarRequest);
    const loading = useSelector((state) => state.CalendarR.loading);
    useEffect(() => {
        if (calendarId && !verifyCalendar && type !== 'reschedule')
            dispatch(verifyCalendarRequest({ calendarId, tenantId }));
        if (calendarId && !verifyNewCalendar && type === 'reschedule')
            dispatch(verifyNewCalendarRequest({ calendarId, tenantId }));
    }, [calendarId, verifyCalendar, verifyNewCalendar]);

    return (
        <CandidateSlots
            verifyCalendar={type === 'reschedule' ? verifyNewCalendar : verifyCalendar}
            interviewId={interviewId}
            type={type}
            loading={loading}
            tenantId={tenantId}
        />
    );
};

export default CandidateCalendarSync;
